import { useI18n } from 'modules/i18n';
import PropTypes from 'prop-types';

// TODO: Rename DeleteItemForm to a generic confirmation form and replace deletion-specific test IDs.
export default function DeleteItemForm({
    children,
    onSubmit,
    onCancel,
    submitTextKey = 'delete',
}) {
    const { t } = useI18n();

    return (
        <form className="Form">
            {children}

            <div className="Form-footer u-mt">
                <button
                    type="button"
                    className="Button Button--primaryAction"
                    onClick={onSubmit}
                    data-testid="delete-item-confirm-button"
                >
                    {t(submitTextKey)}
                </button>
                <button
                    type="button"
                    className="Button Button--secondaryAction"
                    onClick={onCancel}
                    data-testid="delete-item-cancel-button"
                >
                    {t('cancel')}
                </button>
            </div>
        </form>
    );
}

DeleteItemForm.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    submitTextKey: PropTypes.string,
};
